/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/


import * as React from 'react';
import { useDispatch } from 'react-redux';
import { Formik } from 'formik';
import { Typography } from '@mui/material';
import * as Yup from 'yup';
import { toast } from 'react-toastify';
import RoleForm from './RoleForm';
import { createRole } from '../../../../../../services/role/Role';
import { getAllRole } from '../../../../../../store/reducers/role/roleAction';

const RoleCreation = ({ handleClose }) => {
    const dispatch = useDispatch()
    const handleSubmit = async ({ roleName }) => {
        try {
            await createRole({ roleName })
            toast.success('Role was registred successfully');
            handleClose();
            await dispatch(getAllRole()).unwrap();
        } catch (error) {
            toast.error(error?.response?.data?.error?.message);
        }
    }

    return (
        <>
            <Typography variant='h2' color="primary" align='center' style={{ margin: '30px' }}>Role Registration</Typography>
            <Formik
                initialValues={{
                    roleName: ''
                }}
                validationSchema={Yup.object().shape({
                    roleName: Yup.string().min(2).max(40).required('Role Name is required.')
                })}
                onSubmit={(
                    values
                ) => {
                    handleSubmit(values)
                }
                }
            >
                {({ values, handleBlur, handleChange, isSubmitting, setFieldValue, errors, touched }) => (

                    <RoleForm
                        values={values}
                        handleBlur={handleBlur}
                        handleChange={handleChange}
                        setFieldValue={setFieldValue}
                        isSubmitting={isSubmitting}
                        handleClose={handleClose}
                        errors={errors}
                        touched={touched}
                    />
                )}
            </Formik>
        </>
    )

}


export default RoleCreation;
